import "./jquery-global.js";

import "parsleyjs/src/parsley.js";
import "parsleyjs/src/i18n/fr.js";
import "parsleyjs/src/i18n/es.js";
import "parsleyjs/src/i18n/it.js";
import "parsleyjs/src/i18n/de.js";
import "jquery-ui/dist/jquery-ui.js";
import "@hotwired/turbo-rails";
// import "jquery-smooth-scroll/jquery.smooth-scroll.js";

import "../../../../frontend/src/shared/bootstrap-select-global.js";
import { initializeProfileEditEmailValidation } from "../../../../frontend/src/shared/profile_email_validation.js";

import moment from "moment/src/moment.js";
import "moment/src/locale/de.js";
import "moment/src/locale/es.js";
import "moment/src/locale/fr.js";
import "moment/src/locale/it.js";
// import "flexslider/jquery.flexslider.js";
import "@vendor/jquery.rwdImageMaps.js";
import "@vendor/jquery.capsChecker.js";
import "@vendor/handlebars-v1.2.0";

import DataTable from 'datatables.net-dt';
import 'datatables.net-buttons-dt';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import "./organizations/base.js";

import "./custom.js";
import "./events.js";
import "./navbar.js";
import "./tutors/custom.js";
import "./tableau/custom.js";
import "./school-modal.js";
import "./user-destroy-modal.js";
import "./child-destroy-modal.js";

// Showcase js
import "./showcases.js";

// window.addEventListener('turbo:load', function() {
//   console.log('in load turbo')

$(function () {
  window.Parsley.addValidator("checkOverAge", {
    requirementType: "string",
    validateString: function (value, requirements) {
      var classId = requirements.split("-")[0];
      var age = requirements.split("-")[1];
      var day = $("." + classId + "-day").val(),
        month = $("." + classId + "-month").val(),
        year = $("." + classId + "-year").val();

      if (isNumeric(day) === false || isNumeric(month) === false || isNumeric(year) === false) {
        return true;
      }

      day = zeroPad(day, 2);
      month = zeroPad(month, 2);
      year = zeroPad(year, 4);

      var inputDate = moment(year + "-" + month + "-" + day, "YYYY-MM-DD");
      var birthDate = moment().subtract(age, "years");

      if (inputDate.isValid() && inputDate <= birthDate) {
        return true;
      } else {
        return false;
      }
    },
  });

  window.Parsley.addValidator("checkUnderAge", {
    requirementType: "string",
    validateString: function (value, requirements) {
      var classId = requirements.split("-")[0];
      var age = requirements.split("-")[1];
      var day = $("." + classId + "-day").val(),
        month = $("." + classId + "-month").val(),
        year = $("." + classId + "-year").val();

      if (isNumeric(day) === false || isNumeric(month) === false || isNumeric(year) === false) {
        return true;
      }

      day = zeroPad(day, 2);
      month = zeroPad(month, 2);
      year = zeroPad(year, 4);

      var inputDate = moment(year + "-" + month + "-" + day, "YYYY-MM-DD");
      var birthDate = moment().subtract(age, "years");

      if (inputDate.isValid() && inputDate > birthDate) {
        return true;
      } else {
        return false;
      }
    },
  });

  window.Parsley.addValidator("rejectPattern", {
    requirementType: "string",
    validateString: function (value, requirement) {
      // check that the email value does not contain http or // via regex
      var regex = new RegExp(requirement);
      return !regex.test(value);
    },
  });

  window.Parsley.addValidator("rejectEmoji", {
    // requirementType: "string",
    validateString: function (value) {
      var regex = new RegExp(
        /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/gu
      );
      return !regex.test(value);
    },
  });

  function extractJson(xhr) {
    if (xhr && typeof xhr === "object") {
      if (xhr.responseJSON) {
        return xhr.responseJSON;
      }

      if (xhr.responseText) {
        try {
          return JSON.parse(xhr.responseText);
        } catch (error) {
          console.warn("[signup] Unable to parse async validator response JSON", error);
        }
      }
    }

    return null;
  }

  window.Parsley.addAsyncValidator(
    "emailUnique",
    function (xhr) {
      // Ritorna true anche se la richiesta non funziona per far
      // comunque andare avanti l'utente.
      // La validazione della mail c'è comunque alla fine del form.
      if (xhr.status !== 200) {
        return true;
      }

      var payload = extractJson(xhr);
      if (payload && Object.prototype.hasOwnProperty.call(payload, "found")) {
        return !payload.found;
      }

      return true;
    },
    "/api/v5/users/email/check?email={value}"
  );

  window.Parsley.addAsyncValidator(
    "emailValid",
    function (xhr) {
      // Ritorna true anche se la richiesta non funziona per far
      // comunque andare avanti l'utente.
      // La validazione della mail c'è comunque alla fine del form.
      if (xhr.status !== 200) {
        return true;
      }

      var payload = extractJson(xhr);
      if (payload && Object.prototype.hasOwnProperty.call(payload, "status")) {
        return payload.status === "ok";
      }

      return true;
    },
    "/api/v5/users/email/is-valid?email={value}"
  );

  window.Parsley.on("field:error", function (fieldInstance) {
    if (!fieldInstance._ui || !fieldInstance._ui.$errorsWrapper) return;

    var seenErrors = {};
    fieldInstance._ui.$errorsWrapper.find("li").each(function () {
      var errorKey = $(this).attr("class") + "|" + $(this).text();
      if (seenErrors[errorKey]) {
        $(this).remove();
      } else {
        seenErrors[errorKey] = true;
      }
    });
  });

  // Nel caso in cui la data di nascita non viene passata dal provider
  // oauth, non si può avanzare automaticamente il primo step
  if (isOauth() && isBirthdaySet()) {
    $("#new_user").hide();
    $("#oauth-spinner").show();
  }

  // chrome workaround, altrimenti non onora 'autocomplete='off'
  $(".selectpicker").attr("autocomplete", "random");

  $('[data-bs-toggle="tooltip"]').tooltip();

  if (/Android|webOS|BlackBerry/i.test(navigator.userAgent)) {
    $(".selectpicker").selectpicker("mobile");
  }

  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    $(".selectpicker").removeClass("selectpicker");
  }

  // chrome workaround, altrimenti non onora 'autocomplete='off''
  $(".schools_city").attr("autocomplete", "random");
  $("#city").attr("autocomplete", "none");

  $("#countainer_schools").on("autocompletechange", ".dynamic_section .user-field .schools_city", function () {
    var parent = $(this).closest(".dynamic_section");

    window.clearProfileSchoolDependents(parent, {
      preserveCoursePlaceholder: true,
    });

    window.updateProfileSchoolBlock(parent, {
      preserveSelections: true,
    });
    window.syncProfileSchoolBlockFields(parent);
  });

  $(document).on("change", "#countainer_schools select.profile-school-region", function () {
    var container = $(this).closest(".dynamic_section");
    var city = container.find("input.schools_city");

    city.val("");
    city.removeData("id");
    city.removeAttr("data-id");
    city.removeData("selectedLabel");

    window.clearProfileSchoolDependents(container);
    window.syncProfileSchoolCityAutocomplete(container);

    window.updateProfileSchoolBlock(container);
    window.syncProfileSchoolBlockFields(container);
  });

  initializeProfileEditEmailValidation();

  $(document).on("change", "#countainer_schools select.profile-school-nation", function () {
    var container = $(this).closest(".dynamic_section");
    var region = container.find("select.profile-school-region");
    var city = container.find("input.schools_city");

    if ($(this).val() === "NP") {
      region.val("");
      city.val("");
      city.removeData("id");
      city.removeAttr("data-id");
      city.removeData("selectedLabel");
      city.removeAttr("data-selected-label");
      container.find(".school-type input[type='radio']").prop("checked", false);
      window.clearProfileSchoolDependents(container);
    } else {
      window.syncProfileSchoolCityAutocomplete(container);
    }

    window.updateProfileSchoolBlock(container);
    window.syncProfileSchoolBlockFields(container);
  });

  $(document).on("input", "#countainer_schools input.schools_city", function () {
    var city = $(this);
    var selectedLabel = city.data("selectedLabel");

    if (!city.is(":focus")) {
      return;
    }

    if (selectedLabel && city.val() === selectedLabel) {
      return;
    }

    city.removeData("id");
    city.removeAttr("data-id");
    city.removeData("selectedLabel");

    var container = city.closest(".dynamic_section");
    window.clearProfileSchoolDependents(container);
    window.updateProfileSchoolBlock(container);
    window.syncProfileSchoolBlockFields(container);
  });

  $(document).on("change", "#countainer_schools select.schools_select", function () {
    var container = $(this).closest(".dynamic_section");
    var course = container.find("select.courses_select");
    var schoolSelect = $(this);

    schoolSelect.data("selectedSchoolCode", schoolSelect.val() || "");
    window.syncProfileSchoolBlockFields(container);

    if (course.length === 0) {
      return;
    }

    course.find("option").remove();

    if ($(this).val()) {
      fill_courses(course, $(this).val());
      course.prop("disabled", false);
    } else {
      course.append("<option value=''> </option>");
      course.val("");
      course.prop("disabled", !window.profileSchoolUsesPublicSchoolFields(container));
    }

  });

  $(document).on("change", "#countainer_schools .school-type input[type='radio']", function () {
    window.applyProfileSchoolType($(this));
    window.syncProfileSchoolBlockFields($(this).closest(".dynamic_section"));
  });

  $(document).on("change", "#countainer_schools select.profile-school-course", function () {
    window.syncProfileSchoolBlockFields($(this).closest(".dynamic_section"));
  });

  $(document).on("submit", "form", function () {
    var form = $(this);

    if (form.find("#countainer_schools").length === 0) {
      return;
    }

    form.find("#countainer_schools .dynamic_section").each(function () {
      window.syncProfileSchoolBlockFields($(this));
    });
  });

  $(function () {
    setTimeout(function () {
      $(".alert").slideUp(700, "linear");
    }, 7000);
  });

  $("select[name='filter_for_publisher_select']").on("change", function () {
    var url = $(this).val();
    if (url) {
      // require a URL
      window.location = url; // redirect
    }
    return false;
  });

  $("header.user-role-select-form .signup-steps input:submit[name!='commit']").on("click", function (event) {
    event.preventDefault();
    manageStepChange(this);
  });

  $("header.user-role-select-form .signup-steps input:submit[name='commit']").on("click", function (event) {
    event.preventDefault();
    $(this).closest("form").submit();
  });

  $("header.user-role-select-form .flat-box-steps-circle div").on("click", function () {
    manageStepCircles(this);
  });

  var userLang = navigator.language || navigator.userLanguage;
  userLang = userLang.substring(0, 2).toLowerCase();

  if (!["it", "en", "fr", "de", "es"].includes(userLang)) {
    userLang = "en";
  }
  window.Parsley.setLocale(userLang);

  if ($("#new_user").length != 0) {
    $("#new_user").parsley();
  }

  // New parent link form
  $("#new_connect_existing_account_form").parsley();

  $("#connect_existing_account_form_email").on("input change keyup", function () {
    manageNewParentLinkDisableBtn(this);
  });

  $("header.new_user_relation_form .signup-steps input:submit[name='commit']").on("click", function (event) {
    event.preventDefault();
    $(this).closest("form").submit();
  });
  // End New parent link form

  $("header.user-role-select-form input").on("input change keyup", function () {
    manageInputChange(this);
  });

  $(".step-1-adult input").on("input change keyup", function () {
    manageDisableBtn(this, 1);
  });

  $(".step-2-adult input").on("input change keyup", function () {
    manageDisableBtn(this, 2);
  });

  $(".step-1-adult select").on("input change keyup", function () {
    manageDisableBtn(this, 1);
  });

  $(".step-2-adult select").on("input change keyup", function () {
    if (this.id === "nation") return;

    manageDisableBtn(this, 2);
  });

  $(".step-3-adult input").on("input change keyup", function () {
    manageDisableBtn(this, 3);
  });

  $(".step-1-parent input").on("input change keyup", function () {
    manageDisableBtn(this, 1);
  });

  $(".step-2-parent input").on("input change keyup", function () {
    manageDisableBtn(this, 2);
  });

  $(".step-1-parent select").on("input change keyup", function () {
    if (!isDateFullyEntered()) return;

    $(".userbday-day").parsley().validate();
    $(".userbday-month").parsley().validate();
    $(".userbday-year").parsley().validate();
    manageDisableBtn(this, 1);
  });

  $(".step-1-teacher input").on("input change keyup", function () {
    manageDisableBtn(this, 1);
  });

  $(".step-1-adult select").on("input change keyup", function () {
    if (!isDateFullyEntered()) return;

    $(".userbday-day").parsley().validate();
    $(".userbday-month").parsley().validate();
    $(".userbday-year").parsley().validate();
    manageDisableBtn(this, 1);
  });

  $(".step-2-teacher input").on("input change keyup", function () {
    manageDisableBtn(this, 2);
  });

  $(".step-1-teacher select").on("input change keyup", function () {
    if (!isDateFullyEntered()) return;

    $(".userbday-day").parsley().validate();
    $(".userbday-month").parsley().validate();
    $(".userbday-year").parsley().validate();
    manageDisableBtn(this, 1);
  });

  $(".step-2-teacher select").on("input change keyup", function () {
    if (this.id === "nation") return;

    manageDisableBtn(this, 2);
  });

  $(".step-1-young input").on("input change keyup", function () {
    manageDisableBtn(this, 1);
  });

  $(".step-1-young select").on("input change keyup", function () {
    if (!isDateFullyEntered()) return;

    $(".userbday-day").parsley().validate();
    $(".userbday-month").parsley().validate();
    $(".userbday-year").parsley().validate();
    manageDisableBtn(this, 1);
  });

  $(".step-2-young input").on("input change keyup", function () {
    manageDisableBtn(this, 2);
  });

  $(".step-2-young select").on("input change keyup", function () {
    if (this.id === "nation") return;

    manageDisableBtn(this, 2);
  });

  $(".step-3-young input").on("input change keyup", function () {
    manageDisableBtn(this, 3);
  });

  $(".step-3-teacher input").on("input change keyup", function () {
    manageDisableBtn(this, 3);
  });

  $(".required-by-fake-email").on("input change keyup", function () {
    $("#new_user")
      .parsley()
      .whenValid({ group: "fake_email" })
      .then(function () {
        $("#checkbox-form-fake-email").removeAttr("disabled"); // firefox compatibility
      })
      .catch(function () {
        $("#checkbox-form-fake-email").prop("disabled", true);
      });
  });

  var region_sel = $("#region_id");
  if (region_sel.length > 0) {
    fill_regions(region_sel);
  }

  $(".ui-autocomplete").on("click", function (event) {
    if ($('input[name="school_type"]:checked').val() === "public") {
      console.log("public");
      var sel = $("#school_code");
      var city = $("#city_id").data();
      sel.find("option").remove();
      fill_schools(sel, city.id);
    }
  });

  // required to avoid double-click on submit button
  $(".btn-signup-flow-last").one("click", function (event) {
    $(this).prop("disabled", true);
  });
  $(".btn-signup-flow-last").dblclick(function (e) {
    e.preventDefault();
  });

  $("#new_bsmart_activation_form").submit(function (event) {
    $(".btn.btn-default.btn-eli.btn-bsmart").prop("disabled", true);
  });
  $(".btn.btn-default.btn-eli.btn-bsmart").dblclick(function (e) {
    e.preventDefault();
  });

  $("#header.user-role-select-form select#nation").on("change", function () {
    var schoolType = $("input[name='school_type']:checked").val();
    var schoolCode = $("#school_code");
    var schoolDetailField = window.signupSchoolDetailField();

    if ($(this).val() == "NP") {
      $(".school-inputs").hide();
      window.signupSchoolDetailWrapper().hide();
      $(".user-field.school-name").hide();
      $("#city_id").prop("required", false);
      $("#city_id").attr("data-parsley-required", "false");
      $("#region_id").prop("required", false);
      $("#region_id").attr("data-parsley-required", "false");
      schoolCode.prop("required", false);
      schoolCode.attr("data-parsley-required", "false");
      if (schoolDetailField.length > 0) {
        schoolDetailField.prop("required", false);
        schoolDetailField.attr("data-parsley-required", "false");
        schoolDetailField.val("");
      }
      $("#city_id").val("");
      $("input[name='school_type']").prop("required", false);
      $("input[name='school_type']").attr("data-parsley-required", "false");
      $('input[name="school_type"]').prop("checked", false);
      schoolCode.empty();
      $("#nation").parsley().validate();
    } else {
      $(".school-inputs").not(".school-type", ".school-details").show();
      $("#city_id").prop("required", true);
      $("#city_id").attr("data-parsley-required", "true");
      $("#region_id").prop("required", true);
      $("#region_id").attr("data-parsley-required", "true");
      $("input[name='school_type']").prop("required", true);
      $("input[name='school_type']").attr("data-parsley-required", "true");

      schoolCode.prop("required", schoolType === "public");
      schoolCode.attr("data-parsley-required", schoolType === "public" ? "true" : "false");

      if (schoolDetailField.length > 0) {
        var schoolDetailRequired = schoolType === "public" && Boolean(schoolCode.val());

        schoolDetailField.prop("required", schoolDetailRequired);
        schoolDetailField.attr("data-parsley-required", schoolDetailRequired ? "true" : "false");
      }
    }

    manageDisableBtn(this, 2);
  });

  $("#school_code").on("change", function () {
    var schoolDetailField = window.signupSchoolDetailField();
    var schoolDetailWrapper = window.signupSchoolDetailWrapper();

    if ($(this).val() !== "") {
      if (schoolDetailField.length > 0) {
        fill_courses(schoolDetailField, $(this).val());
        schoolDetailField.prop("required", true);
        schoolDetailField.attr("data-parsley-required", "true");
        schoolDetailWrapper.show();
      }
    } else {
      if (schoolDetailField.length > 0) {
        schoolDetailField.find("option").remove();
        schoolDetailField.val("");
        schoolDetailField.prop("required", false);
        schoolDetailField.attr("data-parsley-required", "false");
        schoolDetailWrapper.hide();
      }
    }
  });

  $("#user_schools_field").on("change", function () {
    var container = $(this).closest(".dynamic_section");

    if (container.length > 0 && typeof window.isProfileSchoolContainer === "function" && window.isProfileSchoolContainer(container)) {
      return;
    }

    if ($(this).val() !== "") {
      fill_courses($("#course"), $(this).val());
    }
  });

  $("#region_id").on("change", function () {
    var container = $(this).closest(".dynamic_section");

    if (container.length > 0 && typeof window.isProfileSchoolContainer === "function" && window.isProfileSchoolContainer(container)) {
      return;
    }

    if ($(this).val()) {
      $("#city_id").val("");
      $("#city_id").autocomplete("option", "source", "/school_data/cities_list_by_name?region_id=" + $(this).val());
    }
  });

  $("#checkbox-form-fake-email").on("click", function () {
    if ($(this)[0].checked) {
      var name = $("#user_name")[0].value;
      var surname = $("#user_surname")[0].value;
      var birthday = $(".userbday-year")[0].value + "/" + $(".userbday-month")[0].value + "/" + $(".userbday-day")[0].value;
      generate_fake_email($("#user_email")[0], $("#email_confirmation")[0], name, surname, birthday);
      disable_email_fields();
    } else {
      enable_email_fields();
    }
  });

  $("input[name='school_type']").on("click", function () {
    var container = $(this).closest(".dynamic_section");

    if (container.length > 0 && typeof window.isProfileSchoolContainer === "function" && window.isProfileSchoolContainer(container)) {
      window.applyProfileSchoolType($(this));
      return;
    }

    var radio_value = $("input[name='school_type']:checked").val();
    if (radio_value == "public") {
      enable_school_fields();
    } else {
      disable_school_fields(radio_value);
    }
  });

  // Required to trigger validation when step 1 is
  // completely autofilled with oauth data
  $("#user_name").trigger("change");

  // ToS page
  $("#checkbox-tos-group-toggle").on("input change keyup", function () {
    manageTosToggle(this);
  });

  $(".tos-group input:checkbox").on("input change keyup", function () {
    manageTosClick(this);
  });

  manageTosBtn(this);

  // Endo ToS page

  // Is `n` a number or numeric string (eg "3")?
  function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  // Pad `n` with `z` (or `0` by default) to `width`.
  function zeroPad(n, width, z) {
    z = z || "0";
    n = n + "";
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  // Return true if day, month and year is entered and
  // the date is ready to be validated
  // otherwise return false
  // This is needed to prevent starting validation
  // when the user select just the day
  function isDateFullyEntered() {
    var day = $(".userbday-day").val();
    var month = $(".userbday-month").val();
    var year = $(".userbday-year").val();

    if (isNumeric(day) === false || isNumeric(month) === false || isNumeric(year) === false) {
      return false;
    }

    return true;
  }

  if (isOauth()) {
    // SPIEGONE PARTE 4 - 1/10/2020
    // Non perdere le puntate precedenti, su un cerca vicino a te!
    // al momento abbiamo 3 flussi di registrazione: student, teacher e parent.
    // Quest'ultimo prevede solo anagrafica e TOS (niente scuola), quindi saltiamo
    // tutto il pezzo dello spiegone parte 1!
    var flow = $("#user_flow").val();

    if (flow === "parent") {
      advanceStep();
    }
  }
});
// });

$(function () {
  function checkCapsLock() {
    var inputWrappers = $(".check-caps-lock").each(function (i, wrap) {
      var el = null;
      if (wrap.tagName == "INPUT") {
        el = wrap;
        wrap = $(el).closest(".form-group");
      } else {
        el = $(wrap).find("input");
      }
      if (!el) {
        // No input element found, skip
        return true;
      }

      $(el).on("keyup", function (event) {
        // some events has not `getModifierState`
        if (!event.originalEvent.getModifierState) return true;
        var capsLock = event.originalEvent.getModifierState("CapsLock");
        $(this).trigger("hasCapsLockEnable", { status: capsLock });
        if (wrap) {
          $(wrap).find("small.caps-lock-message")[capsLock ? "removeClass" : "addClass"]("hide");
        }
      });
    });
  }

  function showHidePassword(selector) {
    var inputWrappers = $(selector).each(function (i, wrap) {
      var $self = $(this);
      var handler = $(wrap).find(".label-for-show-password");
      handler.on("click", function (event) {
        handler.toggleClass("open");
        let input = $self.find("input[type]");
        if (input.length) {
          input[0].type = input[0].type == "password" ? "text" : "password";
        } else {
          console.warn("cannot find input[type]");
        }
      });
    });
  }
  checkCapsLock();
  showHidePassword(".show-hide-password");
  showHidePassword(".show-hide-password-books");
});

window.isOauth = function isOauth() {
  // SPIEGONE PARTE 3 - 1/10/2020
  // Hai perso le puntate precedenti? cerca è tuo amico!
  // Per evitare di far saltare step quando non siamo in oauth, usiamo il valore
  // di questo input, che al momento viene valorizzato sempre con l'uid della
  // richiesta. OCCHIO!!
  var uid = $("#user_identity_uid").val();
  return uid !== undefined && uid !== null && uid !== "";
};

window.isStepValid = function isStepValid(step) {
  return $("#new_user")
    .parsley({ excluded: "select:hidden" })
    .whenValid({ group: "step_" + step });
};

// workaround to prevent a missing school_code of parsley failures on return key down
$("#new_user").submit(function (event) {
  var radio_school_type = $('#new_user input[name="school_type"]');
  if (radio_school_type.length > 1) {
    var is_school_code_required = radio_school_type.val() === "public";
    var select_scool_code = $('#new_user [name="user[school_code]"]');
    select_scool_code.prop("required", is_school_code_required);
    if (is_school_code_required && select_scool_code.val() == "") {
      event.preventDefault();
    }
  }
});

window.changeStep = function changeStep(step, flow) {
  // SPIEGONE PARTE 2 - 1/10/2020
  // Per le puntate precedenti usa il cerca!
  // Altro spiegone: per come sono fatti i flussi di registrazione oggi, i campi
  // sono tutti dipendenti uno con l'altro e vengono mostrati in sequenza._
  // Questo metodo serve appositamente per gestire i casi "anomali":
  // - Se siamo in oauth e abbiamo i dati della scuola, dobbiamo abilitare a manina
  //   il bottone dello step 2 (se no parsley non lo fa) ed evitare di fare tutto
  //   il teatrino dela mostra/nascondi condizionale. L'utente si trova con tutto
  //   popolato e via.
  // -  Stessa cosa se saltiamo a piè pari lo step 2 (è tutto compilato da oauth
  //    tranne le tos) - se non abilitiamo il pulsante del bottone 2 e l'utente
  //    fa back, rimane incastrato.
  // "Not the code we want, but the want we need." - Dark bweb rises, 2020

  if (step === 2) {
    var prefilled = $("#user_prefilled_region").val();
    var oauth = isOauth();

    if (oauth && prefilled) {
      manageDisableBtn($("#nation"), 2);
    } else {
      $(".school-inputs").not(".school-geo-info").hide();
    }
  }

  if (step === 3) {
    manageDisableBtn($("#nation"), 2);
  }

  $(".signup-steps").hide();
  $(".step-" + step + "-" + flow).show();
  $("html, body").animate({ scrollTop: 0 }, "slow");
};

window.getTargetStep = function getTargetStep(callback) {
  isStepValid(1)
    .then(function () {
      isStepValid(2)
        .then(function () {
          isStepValid(3)
            .then(function () {
              callback(null);
            })
            .catch(function () {
              callback(3);
            });
        })
        .catch(function () {
          callback(2);
        });
    })
    .catch(function () {
      callback(1);
    });
};

window.advanceStep = function advanceStep() {
  getTargetStep(function (step) {
    var flow = $("#user_flow").val();
    if (step) {
      changeStep(step, flow);
      $("#oauth-spinner").hide();
      $("#new_user").show();
    }
  });
};

var getCurrentStep = (window.getCurrentStep = function ($this) {
  var classesParent = $($this).closest(".signup-steps").attr("class").split(" ");
  var curStep = classesParent[2].split("-")[1];
  return curStep;
});

var manageDisableBtn = (window.manageDisableBtn = function ($this, step) {
  var btn = $($this).closest(".signup-steps").find("input[type='submit']");
  $("#new_user")
    .parsley({ excluded: "select:hidden" })
    .whenValid({
      group: "step_" + step,
    })
    .then(function () {
      $(btn).removeAttr("disabled");
    })
    .catch(function () {
      $(btn).prop("disabled", true);
    });
});

// submit button for parent link form
var manageNewParentLinkDisableBtn = (window.manageNewParentLinkDisableBtn = function ($this) {
  var btn = $("input[type='submit']")[0];
  $("#connect_existing_account_form_email")
    .parsley()
    .whenValid()
    .then(function () {
      $(btn).removeAttr("disabled");
    })
    .catch(function () {
      $(btn).prop("disabled", true);
    });
});

var onPrivaciesChange = (window.onPrivaciesChange = function ($this, step) {
  if ($($this).is(":checked")) {
    $($this).attr("value", "1");
    $($this).attr("checked", true);
  } else {
    $($this).attr("value", "");
    $($this).attr("checked", null);
  }
  manageDisableBtn($this, step);
});

var dateSeparator = "/";

var correctCaptcha = (window.correctCaptcha = function (response) {
  $("#recaptcha_status").val("1");
  var classesParent = $(".g-recaptcha").closest(".signup-steps").attr("class").split(" ");
  var curStep = classesParent[2].split("-")[1];
  manageDisableBtn(".g-recaptcha", curStep);
});

var manageStepCircles = (window.manageStepCircles = function ($this) {
  var currentIndex = $($this).siblings(".active").attr("class").split(" ")[0].split("-")[1];
  var selected = $($this).attr("class").split(" ")[0];
  var selectedIndex = selected.split("-")[1];
  if (selectedIndex * 1 < currentIndex * 1) {
    $(".flat-box.signup-steps").hide();
    $(".flat-box-header.signup-steps").hide();
    $(".flat-box-steps-circle").hide();
    $(".flat-box.signup-steps." + selected).show();
    $(".flat-box-header.signup-steps." + selected).show();
    $(".flat-box-steps-circle." + selected).show();
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }
});

var manageInputChange = (window.manageInputChange = function ($this) {
  var step = getCurrentStep($this);
  if ($($this).is(":checkbox")) {
    if ($($this).attr("id") == "checkbox-form-tos_agreement") {
      $(".privacies input:checkbox").prop("checked", $($this).is(":checked"));
      $(".privacies input:checkbox").each(function () {
        onPrivaciesChange(this);
      });
    } else if ($($this).data("privacies") !== undefined) {
      $("#checkbox-form-tos_agreement").prop("checked", false);
      $("#checkbox-form-tos_agreement").attr("value", "");
      onPrivaciesChange($this, step);
    }
  }
});

var manageStepChange = (window.manageStepChange = function ($this) {
  var classesParent = $($this).closest(".signup-steps").attr("class").split(" ");
  var curStep = classesParent[2].split("-")[1];
  var curFlow = classesParent[2].split("-")[2];
  var nextStep = curStep * 1 + 1;

  changeStep(nextStep, curFlow);
});

var gobackSignupFlow = (window.gobackSignupFlow = function ($this) {
  // event.preventDefault();
  var classesParent = $($this).closest(".signup-steps").attr("class").split(" ");
  var curStep = classesParent[2].split("-")[1];
  var curFlow = classesParent[2].split("-")[2];
  var nextStep = curStep * 1 - 1;
  $(".signup-steps").hide();
  $(".step-" + nextStep + "-" + curFlow).show();
  $("html, body").animate({ scrollTop: 0 }, "slow");
});

// ToS acceptance page

var manageTosToggle = (window.manageTosToggle = function ($this) {
  $("#checkbox-form-consent_terms_and_conditions").prop("checked", $("#checkbox-tos-group-toggle")[0].checked);
  $("#checkbox-form-consent_privacy").prop("checked", $("#checkbox-tos-group-toggle")[0].checked);
  $("#checkbox-form-consent_third_party").prop("checked", $("#checkbox-tos-group-toggle")[0].checked);
  $("#checkbox-form-consent_bsmart_products").prop("checked", $("#checkbox-tos-group-toggle")[0].checked);
  manageTosBtn(this);
});

var manageTosClick = (window.manageTosClick = function ($this) {
  // $(".tos-group input:checkbox")
  manageTosBtn(this);
  manageTosToggleCheckbox(this);
});

var allTosChecked = (window.allTosChecked = function ($this) {
  chk1 = $("#checkbox-form-consent_terms_and_conditions")[0].checked;
  chk2 = $("#checkbox-form-consent_privacy")[0].checked;
  chk3 = $("#checkbox-form-consent_third_party")[0].checked;
  chk4 = $("#checkbox-form-consent_bsmart_products")[0].checked;
  return chk1 && chk2 && chk3 && chk4;
});

var mandatoryTosChecked = (window.mandatoryTosChecked = function ($this) {
  // sul caricamento iniziale del sito viene invocato questa funzione, ma $("#checkbox-form-consent_terms_and_conditions")[0]
  // e $("#checkbox-form-consent_privacy")[0] sono undefined quindi undefined.checked ovviamente torna errore
  // per fixarlo ho aggiunto un controllo preventivo ma...
  // FIXME: andrebbe indagato perché viene invocata

  if (!$("#checkbox-form-consent_terms_and_conditions")[0] || !$("#checkbox-form-consent_privacy")[0]) {
    return false;
  }
  return $("#checkbox-form-consent_terms_and_conditions")[0].checked && $("#checkbox-form-consent_privacy")[0].checked;
});

var manageTosToggleCheckbox = (window.manageTosToggleCheckbox = function ($this) {
  $("#checkbox-tos-group-toggle").prop("checked", allTosChecked(this));
});

var manageTosBtn = (window.manageTosBtn = function ($this) {
  var btn = $("#tos-button")[0];
  if (mandatoryTosChecked(this)) {
    $(btn).removeAttr("disabled");
  } else {
    $(btn).prop("disabled", true);
  }
});

// end ToS acceptance page

// SPIEGONE PARTE 5 - 15/01/2021
// Nel caso in cui non viene pre-compilata la parte
// birthday, non si può skippare la prima parte della registazione
// nemmeno in oAuth
window.isBirthdaySet = function isBirthdaySet() {
  var day = $(".userbday-day").val();
  var month = $(".userbday-month").val();
  var year = $(".userbday-year").val();

  return day && month && year;
};

window.fill_regions = function fill_regions(obj, selected) {
  obj.find("option").remove();
  obj.append("<option value=''> </option>");

  $.ajax({
    url: "/school_data/regions_list",
    dataType: "json",
    success: function (result) {
      $.each(result, function (key, value) {
        obj.append("<option value=" + value.id + ">" + value.region_name + "</option>");
      });

      if (selected) {
        obj.val(selected);
      }

      // SPIEGONE PARTE 1 - 1/10/2020
      // Spiegone unico valido per tutto questo discorso: al 1/10/2020 abbiamo
      // deciso di implementare l'avanzamento automatico negli step di registrazione,
      // che al momento sono:
      // 1 - Info anagrafiche (data di nascita, mail e generalità);
      // 2 - Scuola e classe;
      // 3 - TOS
      //
      // Abbiamo 3 possibili flussi di registrazione: student, teacher e parent.
      // I primi due hanno tutti e 3 gli step (il teacher non deve però impostare
      // la classe), mentre l'ultimo salta lo step intermedio.
      //
      // Visto che le chiamate che popolano i vari elenchi di regioni, città,
      // scuole e classi sono tutte asincrone, le facciamo una volta sola (e solo
      // in caso di oauth) qui. Finchè non completano l'utente vede uno spinner.
      if (isOauth()) {
        var prefilled = $("#user_prefilled_region").val();
        if (prefilled) {
          $(obj).val(prefilled);
          var city = $("#user_prefilled_city").val();
          var cityId = $("#user_prefilled_city_id").val();
          $("#city_id").val(city);
          $("#city_id").data("id", cityId);
          $("#city_id").attr("data-id", cityId);
          $(".school-inputs").show();
          $("#radio-form-school-type-public").prop("checked", true);
          var school = $("#school_code");
          var schoolCode = school.val();
          var city = $("#city_id").data();
          var course = $("#course");
          fill_schools($(school), cityId, schoolCode);
          fill_courses($(course), schoolCode, course.val());
        }

        // Nel caso in cui la data di nascita non viene passata dal provider
        // oauth, non si può avanzare automaticamente il primo step
        var birthdaySet = isBirthdaySet();

        if (birthdaySet) {
          advanceStep();
        }
      }
    },
  });
};

window.removeSelectpickerArtifacts = function removeSelectpickerArtifacts(obj) {
  obj = $(obj);

  var sibling = obj.next();

  while (
    sibling.length &&
    (sibling.hasClass("bootstrap-select") ||
      sibling.is("button.dropdown-toggle") ||
      sibling.find(".filter-option-inner-inner").length > 0)
  ) {
    var currentSibling = sibling;
    sibling = sibling.next();
    currentSibling.remove();
  }

  obj.removeData("selectpicker");
};

window.fill_schools = function fill_schools(obj, city, selected) {
  var requestSequence = (obj.data("schoolRequestSequence") || 0) + 1;
  obj.data("schoolRequestSequence", requestSequence);
  obj.data("loadingSchools", true);

  if (selected) {
    obj.data("selectedSchoolCode", selected);
  }

  // console.log("[fill_schools] Start:", obj, city, selected);
  var existingSelectedOption = obj.find("option:selected");
  var fallbackSelectedText = existingSelectedOption.text();
  var fallbackSelectedContent = existingSelectedOption.attr("data-content");

  // Step 1: Tear down any existing bootstrap-select markup before mutating the
  // underlying select, otherwise stale button nodes can survive and duplicate
  // the rendered selection content.
  if (typeof obj.selectpicker === "function") {
    try {
      obj.selectpicker("destroy");
    } catch (error) {
      console.warn("[fill_schools] Unable to destroy selectpicker cleanly", error);
    }
  }
  window.removeSelectpickerArtifacts(obj);
  obj.html("");

  var selectpickerOptions = {
    container: obj.closest("#school-select-modal").length ? "#school-select-modal" : "body",
    size: 2,
    windowPadding: [0, 0, 160, 0],
  };
  // console.log("Options cleared and selectpicker destroyed.");

  if (city) {
    // Step 2: Fetch new options via AJAX
    $.ajax({
      url: "/school_data/schools_list_by_city_id?city_id=" + city,
      dataType: "json",
      success: function (result) {
        if (obj.data("schoolRequestSequence") !== requestSequence) {
          return;
        }

        obj.data("loadingSchools", false);
        var associatedSchoolCodes = [];

        if (window.isProfileSchoolContainer(obj.closest(".dynamic_section"))) {
          associatedSchoolCodes = window.profileSchoolAssociatedSchoolCodes(obj.closest(".dynamic_section"));
        }

        // console.log("[AJAX Success] Result:", result);

        // Step 3: Build new options
        let options = "";
        $.each(result, function (key, value) {
          if (associatedSchoolCodes.indexOf(String(value.school_code)) !== -1 && !(selected && String(selected) === String(value.school_code))) {
            return;
          }

          const typeSafe = String(value.school_type || "").replace(/"/gi, "");
          const nameSafe = String(value.name || "").replace(/"/gi, "");
          const addressSafe = String(value.address || "").replace(/"/gi, "");
          const isSelected = selected && String(selected) === String(value.school_code);
          const searchableText = [typeSafe, nameSafe, addressSafe].filter(Boolean).join(" ");

          const type = "<div class='school-item-type-label'>" + typeSafe + "</div>";
          const name = "<div class='school-item-name-label'>" + nameSafe + "</div>";
          const address = "<div class='school-item-address-label'>" + addressSafe + "</div>";

          const label = "<div class='school-option-item'>" + type + name + address + "</div>";

          options += `<option value="${value.school_code}" data-content="${label}" data-tokens="${searchableText}"${isSelected ? " selected" : ""}>&nbsp;</option>`;
        });

        // Step 4: Append the new options
        obj.html(options);

        if (selected && obj.find('option[value="' + selected + '"]').length === 0 && fallbackSelectedText) {
          obj.append(
            `<option value="${selected}"${fallbackSelectedContent ? ` data-content="${fallbackSelectedContent}"` : ""} selected>${fallbackSelectedText}</option>`
          );
        }
        // console.log("After adding options, select contains:", obj.html());

        // Step 5: Reinitialize selectpicker with the correct container.
        // A fresh init is enough here: calling `refresh` immediately afterwards
        // can cause bootstrap-select to duplicate its internal option data for
        // this control, which then shows the selected item twice in the button.
        obj.selectpicker(selectpickerOptions);

      },
      error: function () {
        obj.data("loadingSchools", false);
        console.error("Failed to load school data for city:", city);
      },
    });
  } else {
    // console.log("No city provided.");
  }
};

window.fill_school_email = function fill_school_email() {
  $("#school-only-pec").hide();
  $("#school-no-email").hide();
  var email = $("#school_email")[0].value;
  $("#mail_from_school")[0].value = email;

  if ($("#school_email option:selected").attr("data-only-pec")) {
    $("#school-only-pec").show();
    $("#school-certification-submit").removeAttr("disabled");
  } else if ($("#school_email option:selected").attr("data-no-email")) {
    $("#school-no-email").show();
    $("#school-certification-submit").prop("disabled", true);
  } else {
    $("#school-certification-submit").removeAttr("disabled");
  }
};

window.fill_courses = function fill_courses(obj, school_code, selected) {
  obj = $(obj);
  obj.find("option").remove();
  obj.append("<option value=''> </option>");

  var requestSequence = (obj.data("courseRequestSequence") || 0) + 1;
  obj.data("courseRequestSequence", requestSequence);

  var previousRequest = obj.data("courseRequest");
  if (previousRequest && typeof previousRequest.abort === "function") {
    previousRequest.abort();
  }

  var request = $.ajax({
    url: "/school_data/courses_by_school_code?school_code=" + school_code,
    dataType: "json",
    success: function (result) {
      if (obj.data("courseRequestSequence") !== requestSequence) {
        return;
      }

      obj.find("option").remove();
      obj.append("<option value=''> </option>");

      $.each(result, function (key, value) {
        obj.append("<option value=" + value.value + ">" + value.text + "</option>");
      });

      if (selected) {
        obj.val(selected);
      }

      obj.removeData("courseRequest");
    },
    error: function (_xhr, status) {
      if (status === "abort" || obj.data("courseRequestSequence") !== requestSequence) {
        return;
      }

      obj.removeData("courseRequest");
    },
  });

  obj.data("courseRequest", request);
};

window.constrainProfileSchoolSelectMenuHeight = function constrainProfileSchoolSelectMenuHeight(selectOrContainer) {
  var source = $(selectOrContainer);
  var container;

  if (source.hasClass("bs-container")) {
    container = source;
  } else if (source.is("select")) {
    var selectpicker = source.data("selectpicker");
    container = selectpicker && selectpicker.$bsContainer ? selectpicker.$bsContainer : source.parent(".bootstrap-select");
  } else {
    container = source.closest(".bs-container, .bootstrap-select");
  }

  if (!container || container.length === 0) {
    return;
  }

  var menu = container.find(".dropdown-menu");
  var menuInner = menu.find(".inner");

  if (menu.length === 0 || menuInner.length === 0) {
    return;
  }

  var visibleItems = menuInner.find("li").filter(function () {
    var item = $(this);

    return item.is(":visible") && item.find("a").length > 0 && !item.hasClass("divider") && !item.hasClass("dropdown-header");
  });

  var innerMaxHeight = 0;

  visibleItems.slice(0, 2).each(function () {
    innerMaxHeight += Math.ceil($(this).outerHeight(true) || 0);
  });

  // Fallback for freshly opened menus before rows are fully measurable.
  if (innerMaxHeight === 0) {
    innerMaxHeight = 192;
  }

  var menuExtrasHeight = 0;
  menuExtrasHeight += Math.ceil(menu.children(".bs-searchbox").outerHeight(true) || 0);
  menuExtrasHeight += Math.ceil(menu.children(".bs-actionsbox").outerHeight(true) || 0);
  menuExtrasHeight += Math.ceil(menu.children(".popover-header").outerHeight(true) || 0);
  menuExtrasHeight += Math.ceil(menu.children(".bs-donebutton").outerHeight(true) || 0);

  menu.css("max-height", innerMaxHeight + menuExtrasHeight + "px");
  menuInner.css({
    "max-height": innerMaxHeight + "px",
    "min-height": 0,
  });
};

$(document).on("shown.bs.select loaded.bs.select refreshed.bs.select rendered.bs.select", "select.school-select", function () {
  window.constrainProfileSchoolSelectMenuHeight($(this));
});

window.profileSchoolTypeForContainer = function profileSchoolTypeForContainer(container) {
  container = $(container);

  if (!window.isProfileSchoolContainer(container)) {
    return null;
  }

  var school = container.find("select.schools_select");
  var checkedRadio = container.find(".school-type input[type='radio']:checked").val();
  var schoolCode = school.val();
  var privateSchoolCode = school.data("private-institutes-school-code");
  var otherSchoolCode = school.data("universities-school-code");

  if (checkedRadio) {
    return checkedRadio;
  }

  if (schoolCode && privateSchoolCode && schoolCode === privateSchoolCode.toString()) {
    return "private";
  }

  if (schoolCode && otherSchoolCode && schoolCode === otherSchoolCode.toString()) {
    return "other";
  }

  if (schoolCode) {
    return "public";
  }

  return null;
};

window.profileSchoolUsesPublicSchoolFields = function profileSchoolUsesPublicSchoolFields(container) {
  return window.profileSchoolTypeForContainer($(container)) === "public";
};

window.profileSchoolNationIsItaly = function profileSchoolNationIsItaly(container) {
  var nation = $(container).find("select.profile-school-nation");

  return nation.length === 0 || nation.val() !== "NP";
};

window.syncProfileSchoolCityAutocomplete = function syncProfileSchoolCityAutocomplete(container) {
  container = $(container);

  if (!window.isProfileSchoolContainer(container)) {
    return;
  }

  var city = container.find("input.schools_city");

  if (city.length === 0) {
    return;
  }

  if (window.profileSchoolNationIsItaly(container)) {
    window.set_autocomplete_city(city);
    return;
  }

  if (city.data("ui-autocomplete")) {
    city.autocomplete("destroy");
  }
};

window.isProfileSchoolContainer = function isProfileSchoolContainer(container) {
  container = $(container);

  return container.closest("#countainer_schools").length > 0 && container.hasClass("school-box");
};

window.profileSchoolRestrictionSelections = function profileSchoolRestrictionSelections(excludedContainer) {
  var excludedNode = excludedContainer ? $(excludedContainer)[0] : null;
  var selections = [];

  $("#countainer_schools .dynamic_section.school-box").each(function () {
    var container = $(this);

    if (!window.isProfileSchoolContainer(container) || (excludedNode && container[0] === excludedNode)) {
      return;
    }

    var schoolSelect = container.find("select.profile-school-select");

    selections.push({
      nation: String(container.find("select.profile-school-nation").val() || container.find("input.profile-school-block-nation").val() || ""),
      cityId: String(container.find("input.profile-school-city").data("id") || container.find("input.profile-school-block-city-id").val() || ""),
      schoolType: String(window.profileSchoolTypeForContainer(container) || container.find("input.profile-school-block-school-type").val() || ""),
      schoolCode: String(schoolSelect.val() || schoolSelect.data("selectedSchoolCode") || container.find("input.profile-school-block-school-code").val() || ""),
    });
  });

  return selections;
};

window.profileSchoolTypeUnavailableForCity = function profileSchoolTypeUnavailableForCity(container, schoolType, cityId) {
  if (!cityId) {
    return false;
  }

  var cityKey = String(cityId);

  return window.profileSchoolRestrictionSelections(container).some(function (selection) {
    return selection.nation !== "NP" && selection.schoolType === schoolType && selection.cityId === cityKey;
  });
};

window.profileSchoolAssociatedSchoolCodes = function profileSchoolAssociatedSchoolCodes(excludedContainer) {
  return window.profileSchoolRestrictionSelections(excludedContainer)
    .map(function (selection) {
      return selection.schoolCode;
    })
    .filter(Boolean);
};

window.syncProfileSchoolBlockFields = function syncProfileSchoolBlockFields(container) {
  container = $(container);

  if (!window.isProfileSchoolContainer(container)) {
    return;
  }

  var nation = container.find("select.profile-school-nation").val() || "";
  var region = container.find("select.profile-school-region").val() || "";
  var city = container.find("input.profile-school-city");
  var schoolType = container.find(".school-type input[type='radio']:checked").val() || "";
  var schoolSelect = container.find("select.profile-school-select");
  var school = schoolSelect.val() || "";
  var course = container.find("select.profile-school-course").val() || "";

  if (!school && schoolSelect.data("loadingSchools")) {
    school = schoolSelect.data("selectedSchoolCode") || container.find("input.profile-school-block-school-code").val() || "";
  }

  container.find("input.profile-school-block-nation").val(nation);
  container.find("input.profile-school-block-region-id").val(region);
  container.find("input.profile-school-block-city-name").val(city.val() || "");
  container.find("input.profile-school-block-city-id").val(city.data("id") || "");
  container.find("input.profile-school-block-school-type").val(schoolType);
  container.find("input.profile-school-block-school-code").val(school);
  container.find("input.profile-school-block-course-id").val(course);
};

window.setProfileSchoolBlockInputNames = function setProfileSchoolBlockInputNames(container, index) {
  container = $(container);

  if (!window.isProfileSchoolContainer(container)) {
    return;
  }

  container.find("input.profile-school-block-nation").attr("name", "profile_school_blocks[" + index + "][nation]");
  container.find("input.profile-school-block-region-id").attr("name", "profile_school_blocks[" + index + "][region_id]");
  container.find("input.profile-school-block-city-name").attr("name", "profile_school_blocks[" + index + "][city_name]");
  container.find("input.profile-school-block-city-id").attr("name", "profile_school_blocks[" + index + "][city_id]");
  container.find("input.profile-school-block-school-type").attr("name", "profile_school_blocks[" + index + "][school_type]");
  container.find("input.profile-school-block-school-code").attr("name", "profile_school_blocks[" + index + "][school_code]");
  container.find("input.profile-school-block-course-id").attr("name", "profile_school_blocks[" + index + "][course_id]");
};

window.clearProfileSchoolDependents = function clearProfileSchoolDependents(container, options) {
  options = options || {};

  if (!window.isProfileSchoolContainer(container)) {
    return;
  }

  var school = container.find("select.schools_select");
  var course = container.find("select.courses_select");

  school.find("option").remove();
  school.val("");

  if (school.hasClass("selectpicker")) {
    school.selectpicker("refresh");
  }

  course.find("option").remove();
  if (options.preserveCoursePlaceholder !== false) {
    course.append("<option value=''> </option>");
  }
  course.val("");
};

window.setProfileSchoolFallbackValues = function setProfileSchoolFallbackValues(container, schoolType) {
  if (!window.isProfileSchoolContainer(container)) {
    return false;
  }

  var school = container.find("select.schools_select");
  var course = container.find("select.courses_select");
  var schoolCode = schoolType === "private" ? school.data("private-institutes-school-code") : school.data("universities-school-code");

  if (!schoolCode) {
    return false;
  }

  school.find("option").remove();
  school.append("<option value='" + schoolCode + "'>Other</option>");
  school.val(schoolCode);

  if (school.hasClass("selectpicker")) {
    school.selectpicker("refresh");
  }

  if (course.length > 0) {
    course.find("option").remove();
    course.append("<option value='other'>Other</option>");
    course.val("other");
  }

  return true;
};

window.syncProfileSchoolSelectionRestrictions = function syncProfileSchoolSelectionRestrictions() {
  var blocks = $("#countainer_schools .dynamic_section.school-box");
  var addSchoolRow = $(".add-school-row");

  if (blocks.length === 0 || $(".add_school_link").length === 0) {
    return;
  }

  var npCount = 0;

  blocks.each(function () {
    var container = $(this);
    var nation = container.find("select.profile-school-nation").val();

    if (nation === "NP") {
      npCount += 1;
    }
  });

  blocks.each(function () {
    var container = $(this);
    var nation = container.find("select.profile-school-nation").val();
    var cityId = container.find("input.profile-school-city").data("id") || container.find("input.profile-school-block-city-id").val() || "";
    var npOption = container.find("select.profile-school-nation option[value='NP']");
    var publicInput = container.find(".school-type input[type='radio'][value='public']");
    var publicWrapper = publicInput.closest(".col-sm-12");
    var privateInput = container.find(".school-type input[type='radio'][value='private']");
    var privateWrapper = privateInput.closest(".col-sm-12");
    var otherInput = container.find(".school-type input[type='radio'][value='other']");
    var otherWrapper = otherInput.closest(".col-sm-12");
    var npUnavailable = npCount > 0 && nation !== "NP";
    var privateUnavailable = nation !== "NP" && window.profileSchoolTypeUnavailableForCity(container, "private", cityId);
    var otherUnavailable = nation !== "NP" && window.profileSchoolTypeUnavailableForCity(container, "other", cityId);

    npOption.prop("disabled", npUnavailable);
    npOption.prop("hidden", npUnavailable);

    publicInput.prop("disabled", false);
    publicWrapper.prop("hidden", false);

    privateInput.prop("disabled", privateUnavailable);
    privateWrapper.prop("hidden", privateUnavailable);

    otherInput.prop("disabled", otherUnavailable);
    otherWrapper.prop("hidden", otherUnavailable);
  });

  addSchoolRow.show();
};

window.updateProfileSchoolBlock = function updateProfileSchoolBlock(container, options) {
  container = $(container);
  options = options || {};

  if (!window.isProfileSchoolContainer(container)) {
    return;
  }

  var finalizeProfileSchoolBlockUpdate = function finalizeProfileSchoolBlockUpdate() {
    window.syncProfileSchoolBlockFields(container);
    window.syncProfileSchoolSelectionRestrictions();
  };

  var schoolType = window.profileSchoolTypeForContainer(container);
  var isItaly = window.profileSchoolNationIsItaly(container);
  var city = container.find("input.schools_city");
  var cityId = city.data("id");
  var school = container.find("select.schools_select");
  var course = container.find("select.courses_select");
  var region = container.find("select.profile-school-region");
  var schoolTypeInputs = container.find(".school-type input[type='radio']");
  var isPublic = schoolType === "public";
  var hasSelectedCity = Boolean(cityId);
  var selectedSchool = school.val() || school.data("selectedSchoolCode");
  var selectedCourse = course.val();
  var schoolTypeRow = container.find(".school-type");
  var schoolDetailsRow = container.find(".school-details");
  var shouldShowSchoolType = isItaly && hasSelectedCity;
  var shouldShowSchoolDetails = shouldShowSchoolType && isPublic;

  container.find(".school-geo-info").toggle(isItaly);
  container.find(".school-geo-info .user-field.col-sm-5").toggle(isItaly);
  container.toggleClass("profile-school-city-selected", shouldShowSchoolType);
  container.toggleClass("profile-school-public-selected", shouldShowSchoolDetails);
  schoolTypeRow.prop("hidden", !shouldShowSchoolType).toggle(shouldShowSchoolType);
  schoolDetailsRow.prop("hidden", !shouldShowSchoolDetails).toggle(shouldShowSchoolDetails);

  region.prop("required", isItaly);
  region.attr("data-parsley-required", isItaly ? "true" : "false");
  city.prop("required", isItaly);
  city.attr("data-parsley-required", isItaly ? "true" : "false");
  schoolTypeInputs.prop("required", isItaly && hasSelectedCity);
  schoolTypeInputs.attr("data-parsley-required", isItaly && hasSelectedCity ? "true" : "false");

  school.prop("required", isItaly && hasSelectedCity && isPublic);
  school.attr("data-parsley-required", isItaly && hasSelectedCity && isPublic ? "true" : "false");

  if (course.length > 0) {
    course.prop("required", isItaly && hasSelectedCity && isPublic);
    course.attr("data-parsley-required", isItaly && hasSelectedCity && isPublic ? "true" : "false");
    course.prop("disabled", !(isItaly && hasSelectedCity && isPublic));
  }

  if (!isItaly) {
    if (!options.preserveSelections) {
      window.clearProfileSchoolDependents(container);
    }
    finalizeProfileSchoolBlockUpdate();
    return;
  }

  if (!schoolType) {
    if (!options.preserveSelections) {
      window.clearProfileSchoolDependents(container);
    }
    finalizeProfileSchoolBlockUpdate();
    return;
  }

  if (!isPublic) {
    if (!window.setProfileSchoolFallbackValues(container, schoolType) && !options.preserveSelections) {
      window.clearProfileSchoolDependents(container);
    }
    finalizeProfileSchoolBlockUpdate();
    return;
  }

  if (!cityId) {
    if (!options.preserveSelections) {
      window.clearProfileSchoolDependents(container);
    }
    finalizeProfileSchoolBlockUpdate();
    return;
  }

  fill_schools(school, cityId, selectedSchool);

  if (course.length > 0) {
    if (selectedSchool) {
      fill_courses(course, selectedSchool, selectedCourse);
    } else {
      course.find("option").remove();
      course.append("<option value=''> </option>");
      course.val("");
    }
  }

  finalizeProfileSchoolBlockUpdate();
};

window.applyProfileSchoolType = function applyProfileSchoolType(radio) {
  var container = $(radio).closest(".dynamic_section");

  if (!window.isProfileSchoolContainer(container)) {
    return;
  }

  window.updateProfileSchoolBlock(container);
};

window.generate_fake_email = function generate_fake_email(email_obj, fake_email_obj, name, surname, birthday) {
  $.ajax({
    url: "/profile/generate_fake_email",
    type: "POST",
    data: { name: name, surname: surname, birthday: birthday },
    dataType: "json",
    success: function (result) {
      $.each(result, function (key, value) {
        email_obj.value = value;
        fake_email_obj.value = value;
      });
    },
  });
};

window.signupSchoolDetailField = function signupSchoolDetailField() {
  var course = $("#course");

  if (course.length > 0) {
    return course;
  }

  return $("#classroom");
};

window.signupSchoolDetailWrapper = function signupSchoolDetailWrapper() {
  var course = $(".user-field.course-name");

  if (course.length > 0) {
    return course;
  }

  return $(".user-field.classroom-name");
};

window.disable_email_fields = function disable_email_fields() {
  $("#user_email").prop("readonly", true);
  $("label[for=email_confirmation], #email_confirmation").hide();
  // remove tooltip from email input
  $("#user_email").removeAttr("data-bs-toggle");
  $("#user_email").removeAttr("data-bs-placement");
  $("#user_email").removeAttr("title");
  // data-bs-original-title is also added by bootstrap, so we need to remove it too
  $("#user_email").removeAttr("data-bs-original-title");
};

window.enable_email_fields = function enable_email_fields() {
  $("#user_email")[0].value = "";
  $("#user_email").prop("readonly", false);
  $("#email_confirmation")[0].value = "";
  $("label[for=email_confirmation], #email_confirmation").show();
  // add tooltip from email input
  $("#user_email").attr("data-bs-toggle", "tooltip");
  $("#user_email").attr("data-bs-placement", "top");
  var text = $("#user_email").data("tooltip-title");
  $("#user_email").attr("title", text);
  // data-bs-original-title is also added by bootstrap, so we need to add it too
  $("#user_email").attr("data-bs-original-title", text);
};

window.disable_school_fields = function disable_school_fields(private_institute = false) {
  var school = $("#school_code");
  var school_code = private_institute ? school.data("private-institutes-school-code") : school.data("universities-school-code");
  var schoolDetailField = window.signupSchoolDetailField();
  school.find("option").remove();
  school.append("<option value='" + school_code + "'>Other</option>");
  school.val(school_code);
  school.prop("required", false);
  school.attr("data-parsley-required", "false");

  if (schoolDetailField.length > 0) {
    schoolDetailField.find("option").remove();
    schoolDetailField.append("<option value='other'>Other</option>");
    schoolDetailField.val("other");
    schoolDetailField.prop("required", false);
    schoolDetailField.attr("data-parsley-required", "false");
  }

  window.signupSchoolDetailWrapper().hide();
  $(".school-details").hide();
};

window.enable_school_fields = function enable_school_fields() {
  var school = $("#school_code");
  var city = $("#city_id").data();
  var schoolDetailField = window.signupSchoolDetailField();
  fill_schools(school, city.id);
  school.prop("required", true);
  school.attr("data-parsley-required", "true");

  if (schoolDetailField.length > 0) {
    schoolDetailField.find("option").remove();
    schoolDetailField.val("");
    schoolDetailField.prop("required", false);
    schoolDetailField.attr("data-parsley-required", "false");
  }

  window.signupSchoolDetailWrapper().hide();
  $(".school-details").show();
  $(".user-field.school-name").show();
};

window.fillProfileSchoolDets = function fillProfileSchoolDets() {
  $("#countainer_schools .dynamic_section").each(function (i, container) {
    container = $(container);

    if (container.data("profileSchoolInitialized")) {
      return;
    }

    var region = container.find("select.profile-school-region");
    var nation = container.find("select.profile-school-nation");
    var regionId = region.val();
    var schoolType = window.profileSchoolTypeForContainer(container);
    var radioName = "school_type_" + i;
    var city = container.find("input.profile-school-city");
    var school = container.find("select.profile-school-select");
    var course = container.find("select.profile-school-course");

    if (region.length > 0) {
      region.attr("id", "region_id_" + i);
    }

    window.setProfileSchoolBlockInputNames(container, i);

    if (nation.length > 0) {
      nation.attr("id", "nation_" + i);
    }

    if (city.length > 0) {
      city.attr("id", "city_id_" + i);
    }

    if (school.length > 0) {
      school.attr("id", "user_schools_field_" + i);
      var selectedSchoolCode = school.val() || container.find("input.profile-school-block-school-code").val();
      if (selectedSchoolCode) {
        school.data("selectedSchoolCode", selectedSchoolCode);
      }
    }

    if (course.length > 0) {
      course.attr("id", "course_" + i);
    }

    if (region.length > 0) {
      fill_regions(region, regionId);
    }

    container.find(".school-type input[type='radio']").each(function () {
      $(this).attr("name", radioName);
      $(this).prop("checked", $(this).val() === schoolType);
    });

    window.syncProfileSchoolCityAutocomplete(container);
    window.updateProfileSchoolBlock(container, {
      preserveSelections: true,
    });
    window.syncProfileSchoolBlockFields(container);

    container.data("profileSchoolInitialized", true);
  });

  window.syncProfileSchoolSelectionRestrictions();
};

document.addEventListener("turbo:load", function () {
  if ($("#countainer_schools").length > 0 && typeof window.fillProfileSchoolDets === "function") {
    window.fillProfileSchoolDets();
  }
});
